import { useEffect, useState } from "react";
import {
  onAddAppraisal,
  onGetAllOrgAppraisals,
  onGetOrgAppraisals,
  onUpdateAppraisal,
} from "../services/appraisal";
import { useStateGetter } from "./statehooks/UseStateGettersHook";
import { useStateSetter } from "./statehooks/UseStateSettersHook";
import { toast } from "react-toastify";
import { onAddNotification } from "../services/notifications";
import useEmployeeHook from "./useEmployeeHook";
import useNotificationHook from "./useNotificationHook";

export default () => {
  const { config, SelectedOrg } = useStateGetter();
  const { setLoading } = useStateSetter();
  const [orgappraisals, setorgappraisals] = useState<any[]>([]);
  const [allorgappraisal, setallorgappraisal] = useState<any[]>([]);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { AddNotification } = useNotificationHook();
  const AddAppraisals = async (postdata: any) => {
    try {
      setLoading(true);
      var ress = await onAddAppraisal(postdata, config);
      toast(ress.message);

      //send notifcation to affected users
      {
        postdata.target == "organization" &&
          AddNotification({
            users: selectedOrgEmployees,
            message: "You have a new appraisal assigned to you",
          });
      }
      {
        postdata.target == "employee" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.employeeID == postdata.employeeID
            ),
            message: "You have a new appraisal assigned to you",
          });
      }

      {
        postdata.target == "position" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.positionID == postdata.positionID
            ),
            message: "You have a new appraisal assigned to you",
          });
      }
      {
        postdata.target == "dept" &&
          AddNotification({
            users: selectedOrgEmployees.filter(
              (k: any, key: number) => k.deptID == postdata.deptID
            ),
            message: "You have a new appraisal assigned to you",
          });
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const UpdateAppraisal = async (ApprID: number, postdata: any) => {
    try {
      setLoading(true);
      var ress = await onUpdateAppraisal(ApprID, postdata, config);
      toast(`Appraisal updated to ${postdata.status}`);
    } catch (e) {
      console.log(e);
      toast.error(e);
    } finally {
      setLoading(false);
    }
  };
  const getAllOrgAppraisals = async () => {
    setLoading(true);
    try {
      var res = await onGetAllOrgAppraisals(SelectedOrg.id, config);
      setallorgappraisal(res.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  const getOrgAppraisals = async () => {
    setLoading(true);

    try {
      var res = await onGetOrgAppraisals(SelectedOrg.id, config);
      setorgappraisals(res.data);
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getOrgAppraisals();
    getAllOrgAppraisals();
  }, []);
  return {
    AddAppraisals,
    orgappraisals,
    allorgappraisal,
    UpdateAppraisal,
    getAllOrgAppraisals,
    getOrgAppraisals,
  };
};
